<div class="flex justify-center items-center gap-2">
  <span *ngIf="label">{{ label }}</span>
  <div
    *ngFor="let icon of icons"
    class="w-6 h-6 bg-neutral-700 group-hover/shortcut:bg-yellow-600 text-neutral-100 group-hover/shortcut:text-neutral-900 flex justify-center items-center gap-1 rounded-full"
  >
    <ng-container [ngSwitch]="icon.type">
      <flx-icon
        *ngSwitchCase="IconType.ICON"
        [name]="icon.name"
      />

      <span
        *ngSwitchCase="IconType.KEY"
        [ngClass]="[icon.name.length > 2 ? 'text-[10px]/[16px] font-semibold' : 'text-sm']"
        class="uppercase"
        >{{ icon.name }}</span
      >
    </ng-container>
  </div>
</div>
